import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import React, { Component } from 'react';


class EmailModal extends Component {
    constructor(props){
        super(props);
        this.state={
            setOpen : false,
            open: true
        };
    }

    render(){
      function handleClickOpen() {
        this.setState({
            setOpen : true
        });
    }
        
    function handleClose() {
        this.setState({
            setOpen : false
        });
    }
        return(
            <div>
                 <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open form dialog
      </Button>
      <Dialog open={this.state.open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Share file</DialogTitle>
        <DialogContent>
          {/* <DialogContentText style={{ fontSize: 16}}>
            Please enter the email id to share the file.
          </DialogContentText> */}
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleClose} color="primary">
            Subscribe
          </Button>
        </DialogActions>
      </Dialog>
            </div>
        );
    }
}

export default EmailModal;


// WEBPACK FOOTER //
// ./src/components/Common/EmailModal.js